export default __webpack_public_path__ + "static/media/calc-notebook-icon.e1b51d22.svg";